let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f6nmi")).then(() => parcelRequire('cj15I'));